import { FilterOptionsState } from '@mui/material';

// The active_ingredient catalog spells salts out in full ("GLYPHOSATE
// PRESENT AS THE ISOPROPYLAMINE SALT"), but product labels/import data
// almost always use the abbreviation instead ("Glyphosate 450 IPA") — so a
// plain substring search for "IPA" finds nothing even though that's the most
// common way this salt is actually written. Expands each word of a search
// query to its spelled-out form (word-for-word, so it composes with
// multi-word AND-filtering below) before matching against the real name.
const SALT_SYNONYMS: Record<string, string> = {
  ipa: 'isopropylamine',
  dma: 'dimethylamine',
  mea: 'monoethanolamine',
  mma: 'monomethylamine',
  nh4: 'ammonium',
  na: 'sodium',
  k: 'potassium',
};

const expandSaltSynonyms = (text: string): string[] =>
  text
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => SALT_SYNONYMS[word] ?? word);

/** Autocomplete `filterOptions` for active ingredients: every typed word must appear in the name. */
export const filterActiveIngredientOptions = <T extends { name: string }>(
  options: T[],
  state: FilterOptionsState<T>,
): T[] => {
  const words = expandSaltSynonyms(state.inputValue);
  if (words.length === 0) return options;
  return options.filter((o) => {
    const name = o.name.toLowerCase();
    return words.every((w) => name.includes(w));
  });
};
